import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

// const INITIAL_STATE = {
//     gstStatusFlag : false,
// }

const INITIAL_STATE = {
  auth: false,
  preview: false,
  id: 0,
  open: false,
  data: {},
};

const eInvSlice = createSlice({
  name: "einv",
  initialState: INITIAL_STATE,
  reducers: {
    einvAuth: (state, action) => {
      console.log(action.payload, "action.payload aa");
      state.auth = action.payload;
    },
    einvPreview: (state, action) => {
      console.log(action.payload, "action.payload new");
      state.preview = action.payload.preview;
      state.id = action.payload.id;
    },
    einvId: (state, action) => {
      console.log(action, "action.payload aa");
      state.open = action.payload;
    },
    einvAuthData: (state, action) => {
      console.log(action.payload, "action.payload");
      state.data = action.payload;
    },
    // eOpen: (state, action) => {
    //   console.log(action.payload, "action.payload");
    //   state.open = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => INITIAL_STATE); // THIS LINE
  },
});

export const { einvAuth, einvPreview, einvAuthData, einvId } =
  eInvSlice.actions;
export default eInvSlice.reducer;
